import React, { Component } from 'react';
import './index.styl';
import axios from 'axios';
import moment from 'moment';
import Selectc from 'components/Selectc';
import Zmage from 'react-zmage';

const Option = Selectc.Option;

const clzpre = 'project';

class Project extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataSource: []
        };
    }

    componentDidMount() {
        this.getProjectData();
    }

    getProjectData = () => {
        axios
            .get('/zhgd/projectTab/projectInfo')
            .then(data => {
                this.setState({
                    dataSource: data.result || []
                });
            })
            .catch(e => console.log(e));
    };

    generateProjectArea = () => {
        const data = this.state.dataSource || [];
        return data.map((item, index) => {
            const formatMoment = moment(item.timestamp);
            const mediaArr = item.mediaArr || [];
            return (
                <li className={'single-wrapper'} key={index} id={`item-${item.id}`}>
                    <div className={'left-label'}>
                        <span className={'date'}>{formatMoment.format('YYYY-MM-DD')}</span>
                        <span className={'time'}>{formatMoment.format('hh:mm')}</span>
                    </div>
                    <div className={'middle-area'}>
                        <div className={'item-circle'}></div>
                        <div className={'item-line'}></div>
                    </div>
                    <div className={'right-area'}>
                        <h2>{item.projectName}</h2>
                        <div className={'picture-area'}>
                            {mediaArr.length ? (
                                mediaArr.map((pic, picIndex) => {
                                    if (pic.type === 'picture') {
                                        return (
                                            <Zmage
                                                edge={100}
                                                backdrop="#080935"
                                                key={`pic-${picIndex}`}
                                                src={pic.url}
                                                alt=""
                                            />
                                        );
                                    } else if (pic.type === 'video') {
                                        return <video key={`pic-${picIndex}`} src={pic.url} />;
                                    } else {
                                        return '';
                                    }
                                })
                            ) : (
                                <div>暂无数据</div>
                            )}
                        </div>
                    </div>
                </li>
            );
        });
    };

    selectSingleOption = value => {
        const target = document.getElementById(`item-${value}`);
        if (target) {
            target.scrollIntoView({
                behavior: 'smooth'
            });
        }
    };

    render() {
        return (
            <div className={`${clzpre} com-bg`}>
                <div>
                    <div className={`${clzpre}-top-operation`}>
                        <Selectc style={{ width: '270px', margin: '10px 0 0 24px' }} onChange={this.selectSingleOption}>
                            {(this.state.dataSource || []).map((item, index) => (
                                <Option key={index} value={item.id}>
                                    {item.projectName}
                                </Option>
                            ))}
                        </Selectc>
                    </div>
                    <ul className={`${clzpre}-body`}>{this.generateProjectArea()}</ul>
                </div>
            </div>
        );
    }
}

export default Project;
